<template>
  <div class="h-tenant">
    <select
      v-if="businesses.length > 1"
      class="h-tenant__select"
      aria-label="Which business you are working in"
      :value="currentId"
      :disabled="switching"
      @change="switchTo(Number($event.target.value))"
    >
      <option v-for="b in businesses" :key="b.id" :value="b.id">{{ b.name }}</option>
    </select>
    <span v-else class="h-tenant__name" :title="`You are working in ${vendorName}`">{{ vendorName }}</span>
  </div>
</template>

<script>
import useApi from "@apexl/icarus-core/src/services/api";

// Which business you are in. Everyone sees the name. Someone who may act as a vendor
// gets a list, once there is more than one to choose from. A switch goes back to Home,
// since the page on screen may belong to the business just left.
export default {
  name: 'HermesTenantSwitcher',
  props: {
    vendorName: { type: String, default: 'Apexl Studios' },
    canSwitch: { type: Boolean, default: false },
  },
  data() {
    return { api: useApi(), businesses: [], currentId: null, homeId: null, switching: false };
  },
  mounted() {
    if (this.canSwitch) this.load();
  },
  methods: {
    async load() {
      try {
        const data = await this.api.get('/api/v1/admin/act-as-vendor');
        this.businesses = data.items || [];
        this.currentId = data.current_id;
        this.homeId = data.home_id;
      } catch (e) {
        this.businesses = []; // The name still shows.
      }
    },
    async switchTo(id) {
      if (id === this.currentId) return;
      this.switching = true;
      try {
        if (id === this.homeId) await this.api.delete('/api/v1/admin/act-as-vendor');
        else await this.api.post(`/api/v1/admin/act-as-vendor/${id}`);
        window.location.assign('/admin');
      } catch (e) {
        this.switching = false;
        this.load();
      }
    },
  },
};
</script>

<style scoped>
.h-tenant { display: flex; align-items: center; min-width: 0; font-family: var(--h-font-body, system-ui); }
.h-tenant__select {
  font: inherit; font-size: 13.5px; max-width: 200px; min-width: 0;
  color: var(--h-text-primary, #0F172A); background: var(--h-bg-card, #fff);
  border: 1px solid var(--h-border-strong, #CBD5E1); border-radius: var(--h-radius, 6px); padding: 4px 8px;
}
.h-tenant__select:focus-visible { outline: none; box-shadow: var(--h-focus-ring); }
@media (max-width: 720px) {
  .h-tenant__select { max-width: 130px; }
}
.h-tenant__name {
  font-size: 13.5px; color: var(--h-text-secondary, #64748B);
  overflow: hidden; white-space: nowrap; text-overflow: ellipsis; max-width: 200px;
}
</style>
